export { default as domain, initialState } from './domain'

export const entities = {}
